/* ==================================================================
 *  people_mypage 配下全ページ PC、SP共通
 *  サイドバー設定セクション（通知設定/スカウト関連設定）のトグル・数値入力を Ajax で即時反映
 *
 *  NOTE: Activo 既存の `common/pages/{controller}.js`（ファイル名=コントローラ名）規約から外れる
 *  新規パターン。サイドバーが people_mypage 配下の全コントローラで描画されるため、各コントローラに
 *  同じ呼び出しを書く代わりに ApplicationController 相当のスコープでまとめる。
 * ================================================================== */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードを使う
$(function () {
  if (!$('body.people_mypage').length) return;
  initializeMypageSettingsToggle();
});

function initializeMypageSettingsToggle() {
  $(document).on('change', '.jsMypageSettingToggle', function () {
    const element = this;
    // NOTE: change イベント時点で element.checked は変更後。元に戻す用に反転を保持
    const previousValue = !element.checked;
    updatePersonSetting({
      element,
      field: element.dataset.field,
      value: element.checked,
      rollback: () => { element.checked = previousValue; },
    });
  });

  $(document).on('change', '.jsMypageSettingNumber', function () {
    const element = this;
    // NOTE: change 直前の確定値を保持（連続編集時のロールバック先）
    const previousValue = element.defaultValue;
    updatePersonSetting({
      element,
      field: element.dataset.field,
      value: element.value,
      rollback: () => { element.value = previousValue; },
    });
  });
}

function updatePersonSetting({ element, field, value, rollback }) {
  // NOTE: 設定トグルを持つpartial側で出力されるmetaタグを参照（イベント発火時に取得すれば、初期化時にmetaが存在しないページでもエラーにならない）
  const csrfMeta = document.querySelector('meta[name="csrf-token"]');
  const csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : null;
  const body = { person: { [field]: value }, update_except_mypage: true };

  fetch('/people', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(body),
    credentials: 'same-origin',
  })
    .then((response) => {
      if (!response.ok) throw new Error('Network error');
      return response.json();
    })
    .then(() => {
      // NOTE: 数値フィールド成功時、次回ロールバック先として確定値を更新
      element.defaultValue = element.value;
      toastr.success('設定を更新しました');
    })
    .catch(() => {
      rollback();
      toastr.error('設定の更新に失敗しました');
    });
}
